import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GeneralService } from 'src/app/shared/services/general.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
        private router: Router,
        private gs: GeneralService
    ) {}
 
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const user:any = this.gs.getProfiledata();

      let perfil_id = user?.perfil_id;
      let creci_verified = user?.creci_verified;
      let companyActive = (this.gs.getCompaniesdata()?.accept?.filter(item => ["4","5","6"].indexOf(item.company_perfil_id) > -1) || [])?.length > 0 || !!this.gs.getCompaniesdata()?.invite?.length;
      
      if (perfil_id) {
       
        if((next.routeConfig.path == 'admin' && perfil_id == '1') || perfil_id == '1' || (perfil_id == '3' && creci_verified) || (["2","7"].indexOf(perfil_id) > -1 && companyActive)) {
          return true;
        }
        //this.router.navigate(['error']);
        return false;
      }
      let returnUrl = state.url;
      
      //this.router.navigate(['openModal','AuthenticatorComponent'], { queryParams: { returnUrl: state.url }});
      this.router.navigate(['/home'], { queryParams: { returnUrl: returnUrl }});
      return false;
  }
}
